
namespace TabAurous.Common {
    import fld = Stock.StockItemRow.Fields;
    @Serenity.Decorators.registerClass()
    export class POSStockSelectGrid extends _Ext.GridBase<Stock.StockItemRow, any> {

        static date: Date;
        protected getColumnsKey() { return 'Stock.StockItem'; } 
        protected getIdProperty() { return Stock.StockItemRow.idProperty; }
        protected getLocalTextPrefix() { return Stock.StockItemRow.localTextPrefix; }
        protected getService() { return Stock.StockItemService.baseUrl; }
        protected getInitialTitle() { return null; };
         
        private colums: Slick.Column[]
        radioElement: JQuery;
        radionbutton: JQuery;

        protected getColumns() {

            var _this = this;
            var columns = super.getColumns.call(this);
            this.colums = columns;
          
            return columns;
        };

        constructor(container: JQuery, options) {
            super(container, options);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            (this.view.params as TransactionRequest).VoucherTypeId = 48;

            new Serenity.HeaderFiltersMixin({
                grid: this
            });

            this.slickGrid.setOptions({ rowHeight: 30 });
            this.element.height(650);
            this.addQuickFilter({
                type: Retail.TempEditor,
                title: "",
                separator: false,
                field: "ItemTypeId"
            });

            let propertyName: string = "s-TempEditor s-Retail-TempEditor";
            this.radioElement = $("[class$='" + propertyName + "']").find("label");
            this.radionbutton = $("[class$='" + propertyName + "']").find('input');;

            let item1 = this.radioElement[0];
            let item2 = this.radioElement[1];
            let item3 = this.radioElement[2];

            var innerhtml = item1.innerHTML;
            var part1 = innerhtml.substring(0, innerhtml.lastIndexOf('>'));
            var part2 = innerhtml.substring(innerhtml.lastIndexOf('>'), innerhtml.length);
            var newhtml = part1 + ' checked="checked"' + part2;
            item1.innerHTML = newhtml;


            item1.setAttribute("style", "font-weight: normal;");
            item2.setAttribute("style", "padding-left:50px; font-weight: normal;");
            item3.setAttribute("style", "padding-left:50px;font-weight: normal;");
            return this;
        }
        protected createToolbarExtensions(): void {
            super.createToolbarExtensions()

        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();

            return grid;
        }
        get selectedItems(): Stock.StockItemRow[] {
            var _this = this;
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected usePager() { return true; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };


        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;
            var request = this.view.params as Serenity.ListRequest;
            var itemtype = request.EqualityFilter.ItemTypeId;
            var studded = request.EqualityFilter.Studded;

            this.view.beginUpdate();

            var self = this;
            let filter = function filter(item, args) {
                var linha = (item as Stock.StockItemRow);

                if (itemtype == undefined) {
                    request.EqualityFilter.ItemTypeId = '101';
                    studded = 1;
                    return true;
                }
                else if (itemtype == "101") {
                    studded = 1;
                    var cols = self.colums;
                    cols = cols.filter(x => x.field != "ItemType");
                    self.slickGrid.setColumns(cols);
                    return true;

                }
                else if (itemtype == "104") {
                    var cols = self.colums;
                    cols = cols.filter(x => x.field != "SKU" && x.field != "LineNo" && x.field != "CategoryName" && x.field != "SubCategoryName" && x.field != "ItemType");
                    self.slickGrid.setColumns(cols);
                    return true;
                }
                else if (itemtype == "105") {
                    var cols = self.colums;
                    cols = cols.filter(x => x.field != "SKU" && x.field != 'TypeName' && x.field != "ItemType");
                    self.slickGrid.setColumns(cols);
                    return true;

                }
                return false;
            }

            this.view.setFilter(filter);

            this.view.endUpdate();
            return true;
        }
    } 
}